import _ from 'lodash';
import { observer } from 'mobx-react';
import React, { Suspense, useMemo } from 'react';
import styled from 'styled-components';

import { Anchor, Button, Collapse, Divider, Spin, Typography } from 'antd';

import ShopStore from 'stores/ShopStore';

import {
  ConnectivityFAQ,
  CostFAQ,
  GeneralFAQ,
  GeotabGuide,
  PrivacyFAQ,
  TrainingVideos,
} from './FAQContent';

import { customFleets } from 'shared';

const GMRVFAQ = React.lazy(() => import('./custom/gmrv/GMRV'));
const CardinalCourierFAQ = React.lazy(() =>
  import('./custom/CardinalCourierFAQ').catch(
    () => import('./custom/CardinalCourierFAQ')
  )
);

const { Text } = Typography;

const FAQWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > #anchor-section {
    width: 240px;
  }

  & > #faq-section {
    flex: 1;
  }

  & > #faq-section h4 {
    margin-top: 20px;
  }
`;

const FAQ = observer(() => {
  const isGMRVShop = useMemo(() => {
    return !_.isEmpty(
      _.filter(
        customFleets.gmrv,
        (shopId) => ShopStore.currentShop.id === shopId
      )
    );
  }, [ShopStore.currentShop.id]);

  const isCardinalCourierShop = () => {
    return !_.isEmpty(
      _.filter(
        customFleets.cardinalCourier,
        (shopId) => ShopStore.currentShop.id === shopId
      )
    );
  };

  const faqContent = useMemo(() => {
    return (
      <>
        <div id="anchor-section">
          <Text strong>Navigation</Text>
          <Anchor
            items={[
              {
                key: 'training-videos',
                href: '#training-videos',
                title: 'Training Videos',
              },
              {
                key: 'general-faq',
                href: '#general-faq',
                title: 'General',
              },
              {
                key: 'connectivity-faq',
                href: '#connectivity-faq',
                title: 'GEOTAB Integration Guide',
              },
              {
                key: 'cost-faq',
                href: '#cost-faq',
                title: 'Cost and Billing',
              },
              {
                key: 'privacy-faq',
                href: '#privacy-faq',
                title: 'Privacy',
              },
            ]}
            bounds={200}
          />
        </div>
        <div id="faq-section">
          <div className="accordion-group">
            <h4 id="training-videos">Training Videos</h4>
            <Collapse
              accordion
              items={TrainingVideos.map((el) => ({
                key: el.title,
                label: el.title,
                children: el.content,
              }))}
            />

            <h4 id="general-faq">General FAQ</h4>
            <Collapse
              accordion
              items={GeneralFAQ.map((el) => ({
                key: el.title,
                label: el.title,
                children: <p>{el.content}</p>,
              }))}
            />

            <h4 id="connectivity-faq">Connectivity and Device FAQ</h4>
            <Collapse
              accordion
              items={ConnectivityFAQ.map((el) => ({
                key: el.title,
                label: el.title,
                children: <p>{el.content}</p>,
              }))}
            />

            <h4 id="connectivity-faq">GEOTAB Integration Guide</h4>
            <Collapse
              accordion
              items={GeotabGuide.map((el) => ({
                key: el.title,
                label: el.title,
                children: <p>{el.content}</p>,
              }))}
            />

            <h4 id="cost-faq">Cost and Billing</h4>
            <Collapse
              accordion
              items={CostFAQ.map((el) => ({
                key: el.title,
                label: el.title,
                children: <p>{el.content}</p>,
              }))}
            />

            <h4 id="privacy-faq">Privacy FAQ</h4>
            <Collapse
              accordion
              items={PrivacyFAQ.map((el) => ({
                key: el.title,
                label: el.title,
                children: <p>{el.content}</p>,
              }))}
            />
          </div>
        </div>
      </>
    );
  }, []);

  return (
    <Suspense fallback={<Spin />}>
      {isCardinalCourierShop() ? (
        <CardinalCourierFAQ />
      ) : (
        <>
          <h1>Learning Center</h1>
          <p>
            We are constantly looking for feedback on the dashboard. Please let
            us know what features you would like to have through the contact
            link below.
          </p>
          <Button href="mailto:info@pitstopconnect.com" type="primary">
            Contact Us
          </Button>
          <a href="mailto:info@pitstopconnect.com"> info@pitstopconnect.com</a>
          <Divider />
          <FAQWrapper>{isGMRVShop ? <GMRVFAQ /> : faqContent}</FAQWrapper>
        </>
      )}
    </Suspense>
  );
});

export default FAQ;
